<template>
  <form>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">
          Beschikbare periode {{ this.addOrEditLabel }} voor chauffeur
          <u
            >{{ this.driver.firstName
            }}<template v-if="this.driver.lastNamePrefix !== ''">
              {{ this.driver.lastNamePrefix }}</template
            >
            {{ this.driver.lastName }}</u
          >
        </h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="startDate"
          :rules="{
            required: false,
            regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field
            class="md-datepicker"
            :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
          >
            <label>Start datum</label>
            <md-datepicker
              v-model="startDate"
              name="startDate"
              id="startDate"
              :md-model-type="String"
              md-immediately
              :disabled="true"
            />

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="stopDate"
          :rules="{
            required: false,
            regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field
            class="md-datepicker"
            :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
          >
            <label>Stop datum</label>
            <md-datepicker
              v-model="stopDate"
              :md-model-type="String"
              md-immediately
              :disabled="disabledForAddEdit"
            />

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="weekOddEven"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Week type</label>
            <md-select
              v-model="weekOddEven"
              name="weekOddEven"
              id="weekOddEven"
              required
              :disabled="disabledForEdit"
            >
              <md-option
                v-for="(weekOddEvenOption, index) in [
                  'Even weken',
                  'Oneven weken'
                ]"
                :value="index"
                :key="index"
                >{{ weekOddEvenOption }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="routeId"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Route</label>
            <md-select
              v-model="routeId"
              name="routeId"
              id="routeId"
              required
              :disabled="disabledForEdit"
            >
              <md-option
                v-for="(route, index) in routes"
                :value="route.id"
                :key="index"
                >{{ route.name }}</md-option
              >
            </md-select>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="shiftId"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Dienst</label>
            <md-select
              v-model="shiftId"
              name="shiftId"
              id="shiftId"
              required
              :disabled="disabledForEdit"
            >
              <md-option
                v-for="(shift, index) in shifts"
                :value="shift.id"
                :key="index"
                >{{ shift.name }}</md-option
              >
            </md-select>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          v-for="(availabilityDay, availabilityDayIndex) in availability"
          :key="availabilityDayIndex"
          :name="'availabilityDay' + availabilityDayIndex"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>{{ getDayOfTheWeek(availabilityDayIndex) }}</label>
            <md-select
              v-model="availability[availabilityDayIndex]"
              :name="availability + availabilityDayIndex"
              :id="availability + availabilityDayIndex"
              required
              :disabled="disabledForAddEdit"
            >
              <md-option
                v-for="(selectableAvailabilityTypesDay,
                index) in selectableAvailabilityTypes"
                :value="index"
                :key="index"
                >{{ selectableAvailabilityTypesDay.label }}</md-option
              >
            </md-select>
          </md-field>
        </ValidationProvider>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug</md-button
        >
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";
export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      requestsRemaining: 0,
      errorMessages: [],
      startDate: "",
      stopDate: "",
      weekOddEven: "",
      routeId: "",
      shiftId: "",
      driver: {
        id: "",
        firstName: "",
        lastNamePrefix: "",
        lastName: "",
        email: ""
      },
      availability: {
        1: "9",
        2: "9",
        3: "9",
        4: "9",
        5: "9",
        6: "9",
        7: "9"
      },
      daysOfTheWeek: {
        1: "Maandag",
        2: "Dinsdag",
        3: "Woensdag",
        4: "Donderdag",
        5: "Vrijdag",
        6: "Zaterdag",
        7: "Zondag"
      },
      loaded: {
        driver: false,
        routes: false,
        shifts: false,
        shiftRoutes: false,
        availablePeriods: false,
        selectableAvailabilityTypes: false
      },
      routes: [],
      shifts: [],
      availablePeriods: [],
      selectableAvailabilityTypes: [],
      touched: {
        startDate: false,
        stopDate: false,
        weekOddEven: false,
        routeId: false,
        shiftId: false,
        availablePeriods: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      this.$material.locale.dateFormat = "dd-MM-yyyy";
      setTimeout(this.resetTouched, 100);
    },
    initData() {
      if (this.$route.params.ids !== undefined) {
        let ids = this.$route.params.ids.split(",");

        for (let i in this.availablePeriods) {
          if (ids.indexOf(this.availablePeriods[i].id) != -1) {
            this.availability[
              this.availablePeriods[i].dayOfTheWeek
            ] = this.availablePeriods[i].availability.toString();

            if (this.routeId !== "") {
              continue;
            }

            this.startDate = this.formatDate(
              this.availablePeriods[i].startDate
            );
            this.stopDate = this.formatDate(this.availablePeriods[i].stopDate);
            this.weekOddEven = this.availablePeriods[i].weekOddEven;
            this.routeId = this.availablePeriods[i].route_ids[0];
            this.shiftId = this.availablePeriods[i].shift_ids[0];
          }
        }
      } else {
        this.weekOddEven = this.$route.params.weekType === "odd" ? 1 : 0;
        this.routeId = this.$route.params.routeId;
        this.shiftId = this.$route.params.shiftId;
      }

      setTimeout(this.resetTouched, 100);
    },
    loadRoutes() {
      this.$http.get(this.$apiBaseUrl + "routes").then(
        response => {
          let routes = response.data.routes;

          for (var i = 0; i < routes.length; i++) {
            routes[i].order = routes[i].order.toString();
            routes[i].isreserve = routes[i].isreserve.toString();
            routes[i].shiftIds = [];

            if (this.routeId === null) {
              this.routeId = routes[i].id;
            }
          }

          this.loaded.routes = true;
          this.routes = routes;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van routes",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadShifts() {
      this.$http.get(this.$apiBaseUrl + "shifts").then(
        response => {
          let shifts = response.data.shifts;

          for (let i in shifts) {
            shifts[i]["routeIds"] = [];
          }

          this.loaded.shifts = true;
          this.shifts = shifts;
          this.loadShiftsRoutes();
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van diensten",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadShiftsRoutes() {
      this.$http.get(this.$apiBaseUrl + "shifts/routes").then(
        response => {
          let routeIds = {};
          for (let s in this.shifts) {
            routeIds[this.shifts[s].id] = [];
          }

          for (let shiftId in response.data.shifts_routes) {
            for (let i in response.data.shifts_routes[shiftId]) {
              routeIds[shiftId].push(
                response.data.shifts_routes[shiftId][i].id
              );
            }
          }

          for (let s in this.shifts) {
            this.shifts[s]["routeIds"] = routeIds[this.shifts[s].id];
          }

          this.loaded.shiftRoutes = true;
          this.changeSelectedRoute(this.selectedRouteId);
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van diensten",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadDriver(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "drivers/" + id).then(
        response => {
          this.driver.firstName = response.data.driver.firstName;
          this.driver.lastNamePrefix = response.data.driver.lastNamePrefix;
          this.driver.lastName = response.data.driver.lastName;
          this.driver.email = response.data.driver.email;

          this.requesting = false;
          this.loaded.driver = true;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van chauffeurs", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadAvailablePeriods(userId) {
      this.loaded.availablePeriods = false;
      this.$http
        .get(this.$apiBaseUrl + "drivers/" + userId + "/availableperiods")
        .then(
          response => {
            this.loaded.availablePeriods = true;
            this.availablePeriods = response.data.driverPeriods;
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van beschikbaarheidsperioden",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    loadSelectableAvailabilityTypes() {
      this.$http
        .get(this.$apiBaseUrl + "drivers/selectableavailabilitytypes")
        .then(
          response => {
            this.loaded.selectableAvailabilityTypes = true;
            this.selectableAvailabilityTypes =
              response.data.selectableAvailabilityTypes;
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van beschikbaarheidsperioden",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    changeSelectedRoute(routeId) {
      let shifts = this.getShiftsBySelectedRoute();

      if (shifts.length === 0) {
        this.shiftId = null;

        return;
      }

      for (let i in shifts) {
        if (shifts[i].id === this.shiftId) {
          return;
        }
      }

      this.shiftId = shifts[0].id;
    },
    getShiftsBySelectedRoute() {
      let shifts = [];

      for (let i in this.shifts) {
        if (this.shifts[i].routeIds.indexOf(this.routeId) === -1) {
          continue;
        }

        shifts.push(this.shifts[i]);
      }

      return shifts;
    },
    getDayOfTheWeek(dayNum) {
      for (let dayOfTheWeekNum in this.daysOfTheWeek) {
        if (dayNum == dayOfTheWeekNum) {
          return this.daysOfTheWeek[dayOfTheWeekNum];
        }
      }

      return "Onbekend!";
    },
    formatDate(date) {
      if (typeof date !== "string" || date === "") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    formatDateBack(date) {
      if (typeof date !== "string" || date === "") {
        return null;
      }
      date = date.split("-");
      if (date[2].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    validate() {
      let data = this.getDataToUpPost();

      this.requestsRemaining = 0;
      this.errorMessages = [];

      for (let i in data) {
        if (data[i] !== false) {
          this.requestsRemaining++;
        }
      }

      for (let dataIndex in data) {
        if (data[dataIndex] === false) {
          continue;
        }

        this.$http
          .post(
            this.$apiBaseUrl +
              "drivers/" +
              (data[dataIndex].id !== undefined
                ? ""
                : this.$route.params.userId + "/") +
              "availableperiods/" +
              (data[dataIndex].id !== undefined ? data[dataIndex].id : ""),
            Object.assign({
              startDate: data[dataIndex].startDate,
              stopDate: data[dataIndex].stopDate,
              availability: data[dataIndex].availability,
              weekOddEven: data[dataIndex].weekOddEven,
              dayOfTheWeek: data[dataIndex].dayOfTheWeek,
              route_ids: [this.routeId],
              shift_ids: [this.shiftId]
            })
          )
          .then(
            response => {
              this.requestsRemaining--;

              if (data[dataIndex].id === undefined) {
                this.loadAvailablePeriods(this.$route.params.userId);
              }

              if (
                this.requestsRemaining <= 0 &&
                this.errorMessages.length === 0
              ) {
                setTimeout(this.resetTouched, 100);
                this.notifyVue(
                  "Beschikbaarheid succesvol opgeslagen",
                  "check",
                  "success",
                  5000
                );
                this.$router.go(-1);
              }
              if (
                this.requestsRemaining <= 0 &&
                this.errorMessages.length > 0
              ) {
                let msg =
                  "Fout(en) geconstateerd tijdens opslaan van beschikbaarheid:";

                for (var i in this.errorMessages) {
                  msg += "<br/>\n&bull;&nbsp;" + this.errorMessages[i];
                }

                this.notifyVue(msg, "add_alert", "danger", 0);
              }
            },
            response => {
              this.requestsRemaining--;
              if (response.status === 422) {
                this.submitErrors = response.data.errors;

                for (var i in response.data.errors) {
                  for (var j in response.data.errors[i]) {
                    if (
                      this.errorMessages.indexOf(response.data.errors[i][j]) ===
                      -1
                    ) {
                      this.errorMessages.push(response.data.errors[i][j]);
                    }
                  }
                }

                if (
                  this.requestsRemaining <= 0 &&
                  this.errorMessages.length > 0
                ) {
                  let msg =
                    "Fout geconstateerd tijdens opslaan van beschikbaarheid:";

                  for (var i in this.errorMessages) {
                    msg += "<br/>\n&bull;&nbsp;" + this.errorMessages[i];
                  }

                  this.notifyVue(msg, "add_alert", "danger", 0);
                }
              } else {
                this.notifyVue(
                  "Onbekende fout tijdens opslaan van beschikbaarheid voor " +
                    this.getDayOfTheWeek(data[dataIndex].dayOfTheWeek),
                  "report_problem",
                  "danger",
                  0
                );
              }
            }
          );
      }
    },
    getDataToUpPost() {
      let data = {};

      if (this.$route.params.ids !== undefined) {
        let ids = this.$route.params.ids.split(",");
        for (let i in this.availablePeriods) {
          if (ids.indexOf(this.availablePeriods[i].id) === -1) {
            continue;
          }
          let itemFound = this.availablePeriods[i];

          if (
            itemFound.availability ===
              parseInt(this.availability[itemFound.dayOfTheWeek]) &&
            this.compareDates(
              itemFound.startDate,
              this.formatDateBack(this.startDate)
            ) &&
            this.compareDates(
              itemFound.stopDate,
              this.formatDateBack(this.stopDate)
            )
          ) {
            data[this.availablePeriods[i].dayOfTheWeek] = false;
            continue;
          }

          // Add data
          itemFound.availability = parseInt(
            this.availability[itemFound.dayOfTheWeek]
          );
          itemFound.startDate = this.formatDateBack(this.startDate);
          itemFound.stopDate = this.formatDateBack(this.stopDate);

          data[itemFound.dayOfTheWeek] = itemFound;
          this.availablePeriods[i] = itemFound;
        }
      }

      // Find new days to add
      for (let i in this.availability) {
        if (data[i] !== undefined) {
          continue;
        }

        data[i] = {
          availability: parseInt(this.availability[i]),
          dayOfTheWeek: parseInt(i),
          driver_id: this.$route.params.userId,
          id: undefined,
          route_ids: [this.routeId],
          shift_ids: [this.shiftId],
          startDate: this.formatDateBack(this.startDate),
          stopDate: this.formatDateBack(this.stopDate),
          weekOddEven: parseInt(this.weekOddEven)
        };
      }

      return data;
    },
    compareDates(date1, date2) {
      if (date1 === date2) {
        return true;
      }

      if (
        (date1 === null || date1 === undefined) &&
        (date2 === null || date2 === undefined)
      ) {
        return true;
      }

      return false;
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    resetTouched() {
      this.touched.startDate = false;
      this.touched.stopDate = false;
      this.touched.weekOddEven = false;
      this.touched.routeId = false;
      this.touched.shiftId = false;
      this.touched.availablePeriods = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    addOrEditLabel: function() {
      if (this.$route.params.ids !== undefined) {
        return "bewerken";
      }
      return "toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "date_range";
      }
      return "date_range";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    disabledForAddEdit: function() {
      if (
        this.everythingLoaded === false ||
        this.requesting === true ||
        this.requestsRemaining > 0
      ) {
        return true;
      }

      return false;
    },
    disabledForEdit: function() {
      if (
        this.everythingLoaded === false ||
        this.requesting === true ||
        this.requestsRemaining > 0 ||
        (this.$route.params.ids !== undefined &&
          this.$route.params.ids.length > 0)
      ) {
        return true;
      }

      return false;
    }
  },
  watch: {
    startDate() {
      if (!this.requesting) {
        this.touched.stopDate = true;
      }
    },
    stopDate() {
      if (!this.requesting) {
        this.touched.stopDate = true;
      }
    },
    weekOddEven() {
      if (!this.requesting) {
        this.touched.weekOddEven = true;
      }
    },
    routeId() {
      if (!this.requesting) {
        this.touched.routeId = true;
      }
    },
    shiftId() {
      if (!this.requesting) {
        this.touched.shiftId = true;
      }
    },
    availability: {
      handler: function(val, oldVal) {
        this.touched.availablePeriods = true;
      },
      deep: true
    },
    $route(to, from) {
      this.init();
    },
    everythingLoaded(to, from) {
      if (to === true) {
        this.initData();
      }
    }
  },
  mounted() {
    this.loadRoutes();
    this.loadShifts();
    this.loadDriver(this.$route.params.userId);
    this.loadAvailablePeriods(this.$route.params.userId);
    this.loadSelectableAvailabilityTypes();
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-card-content > span > .md-field.md-datepicker {
  padding-top: 15px;

  &:after {
    bottom: 20px;
  }
}
</style>
